import React, { Component, useEffect } from 'react';
import * as firebase from 'firebase';
import './css/Search.css';
import { NavBarGuest, NavBarAffiliate, NavBarUser } from "./NavBar";
import moment from 'moment';
import { Eventfeed2 } from '../controller/eventfeed2.js'
import './css/Feed.css'
import Delayed from './Delayed';

export const DiscoveryView = (props) => {

    return (
        <div className="firstevent">
            {!props.userLoaded && props.runThis()}
            <div className="NavBar">
                {<NavBarUser />}
            </div>
            <Delayed waitBeforeShow={650}>
                {props.recommendation.length === 0 && <h2 className="warning"> Please add tags to discover. </h2>}
                {/* need to sort recs by time */}
                {props.recommendation.map((subs) => (
                    <Eventfeed2 
                    title={subs.title} 
                    email={subs.email} 
                    start={subs.start} 
                    end={subs.end}
                    location={subs.location}
                    description={subs.description}
                    affiliate={subs.affiliate}
                    check_affiliate = {props.check_affiliate}
                    picture={subs.pictures}
                    inaffiliate_view={false} />
                ))}
            </Delayed>
        </div>
    );
}
